// import $ from 'jquery';
global.jQuery = require('jquery');
window.jQuery = window.$ = require('jquery');
import "bootstrap-sass";

import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'select2';
import 'select2/dist/css/select2.css';
import 'jquery-match-height';

import './shortcodes/announcement-bar.js';
import './shortcodes/calendar-slider.js';
import './shortcodes/slider-header.js';
import './shortcodes/image-slider.js';
import './shortcodes/file-gallery.js';
import './shortcodes/form-search.js';
import './shortcodes/secondary-nav.js';

// Load last in case nested shortcodes are being used
import './shortcodes/column-module.js';

import './shortcodes/admin.js';

(function($) {
    var documentLoad = function() {
        $('table').each(function() {
            var tableElement = this;
            $(tableElement).wrap('<div class="table-wrapper">');
        });

        // Required for accessibility
        $('.social-feed-module a').append('<span class="image-link">Social Icon</span>');
    };
    $(window).on('load', documentLoad);
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/app.js